import { render } from "./NotificationList.vue?vue&type=template&id=655b2bc9"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"

import "./NotificationList.vue?vue&type=style&index=0&id=655b2bc9&lang=css"
script.render = render

export default script